import { LayoutPaddingContextType } from './layoutPadding.types';

export const layoutPaddingContextInitialState: LayoutPaddingContextType = {
  isPaddingDisabled: false,
  setPaddingDisabled: () => null,
};
